import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { personApi } from '../../services/personApi';
import { UpdatePerson } from '../../dtos/Persons/index';
import { personKeys } from './useGetPerson';

export function useUpdatePerson() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Omit<UpdatePerson, 'id'> }) =>
      personApi.update(id, data),
    onSuccess: (response) => {
      if (response.isSuccess) {
        toast.success('Successfully updated person');
        // Invalidate all person queries to refetch from server
        queryClient.invalidateQueries({ queryKey: personKeys.all });
      } else {
        toast.error(`Error: ${response.errorMessage || 'Failed to update person'}`);
      }
    },
    onError: (error: Error) => {
      toast.error(`Error: ${error.message || 'Failed to update person'}`);
    },
  });
}
